import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Loader2, ShieldCheck, ShieldX, GraduationCap } from "lucide-react";
import { verificarCertificado } from "../lib/academia";

export default function VerificarCertificado() {
  const { codigo } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => { verificarCertificado(codigo).then(setData).catch(() => setData({ valido: false })); }, [codigo]);

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-6" data-testid="verificar-cert-page">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl overflow-hidden">
        <div className="bg-[#0B1E36] px-6 py-6 text-center">
          <GraduationCap size={28} className="mx-auto text-amber-400" />
          <p className="mt-2 text-white font-extrabold text-lg">ConstruLink Academia</p>
          <p className="text-slate-300 text-xs">Verificación de certificado</p>
        </div>
        <div className="p-8 text-center">
          {data === null ? (
            <div className="flex items-center justify-center gap-2 text-slate-500"><Loader2 className="animate-spin" size={18} /> Verificando…</div>
          ) : data.valido ? (
            <div data-testid="cert-valido">
              <ShieldCheck size={44} className="mx-auto text-emerald-500" />
              <p className="mt-3 text-emerald-600 font-bold">Certificado válido y auténtico</p>
              <div className="mt-5 text-left space-y-3 bg-slate-50 rounded-xl p-4">
                <Fila k="Alumno" v={data.alumno} />
                <Fila k="Curso" v={data.curso} />
                <Fila k="Código" v={data.codigo} />
                {data.emitido_el && <Fila k="Emitido" v={new Date(data.emitido_el).toLocaleDateString("es-PE", { day: "2-digit", month: "long", year: "numeric" })} />}
              </div>
            </div>
          ) : (
            <div data-testid="cert-invalido">
              <ShieldX size={44} className="mx-auto text-red-500" />
              <p className="mt-3 text-red-600 font-bold">Certificado no encontrado</p>
              <p className="mt-1 text-sm text-slate-500">El código no corresponde a ningún certificado emitido por ConstruLink.</p>
            </div>
          )}
          <Link to="/" className="mt-6 inline-block text-brand-blue font-semibold text-sm hover:underline">Ir a ConstruLink</Link>
        </div>
      </div>
    </div>
  );
}

const Fila = ({ k, v }) => (
  <div className="flex justify-between gap-3 border-b border-slate-100 last:border-0 pb-2 last:pb-0">
    <span className="text-xs font-semibold uppercase tracking-wide text-slate-400">{k}</span>
    <span className="text-sm font-bold text-slate-900 text-right">{v}</span>
  </div>
);
